import { TrashLight, ViewAltLight, ViewHideLight, AddLight, ChooseRow } from '@repo/go-icons';
import { Button } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { AnomaliesModeSelector } from '../../components/AnomaliesModeSelector';
import { Toolbar, ToolbarItem, ToolbarSeparator } from '../../components/Toolbar/Toolbar';
import { ViewSelector } from '../../components/ViewSelector';
import type { ViewStore } from '../../stores/ViewStore';

type Props = {
  viewStore: ViewStore;
  contextHidden: boolean;
  onToggleContext: () => void;
  isEditModeActive: boolean;
  onAddRow: () => void;
  onDelete: () => void;
  onChooseRow: () => void;
  deleteDisabled?: boolean;
};

export const ManualAnomaliesTableToolbar = observer(function ManualAnomaliesTableToolbar({
  viewStore,
  contextHidden,
  onToggleContext,
  isEditModeActive,
  onAddRow,
  onDelete,
  deleteDisabled,
  onChooseRow,
}: Props) {
  const { t } = useTranslation();

  return (
    <Toolbar>
      <ToolbarItem>
        <ViewSelector viewStore={viewStore} disabled={isEditModeActive} />
      </ToolbarItem>
      <ToolbarSeparator />
      <ToolbarItem>
        <AnomaliesModeSelector viewStore={viewStore} disabled={isEditModeActive} />
      </ToolbarItem>
      <ToolbarItem toRight>
        <Button variant="flat" onClick={onToggleContext} icon={contextHidden ? <ViewAltLight /> : <ViewHideLight />}>
          {contextHidden
            ? t('alertsManagerWidget:manualAnomalies.showContext')
            : t('alertsManagerWidget:manualAnomalies.hideContext')}
        </Button>
      </ToolbarItem>
      {isEditModeActive && (
        <>
          <ToolbarItem>
            <Button icon={<AddLight />} onClick={onAddRow}>
              {t('alertsManagerWidget:manualAnomalies.addRow')}
            </Button>
          </ToolbarItem>
          <ToolbarItem>
            <Button variant="danger" icon={<TrashLight />} onClick={onDelete} disabled={deleteDisabled} />
          </ToolbarItem>
        </>
      )}
      <ToolbarItem>{onChooseRow && <Button icon={<ChooseRow />} onClick={onChooseRow} />}</ToolbarItem>
    </Toolbar>
  );
});
